import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "shards-react";

import PageTitle from "../components/common/PageTitle";
import AppView from "./AppView";
import AppDetails from "./AppDetails";
import { Store } from "../flux";

const AppDetailsView = props => {

    const [ App, SetApp ] = useState({});
    const [ Ready, SetReady ] = useState(false);
    const [ ShowAlert, SetShowAlert ] = useState(false);

    useEffect(() => {

        const setData = async () => {

            await SetApp(props.location.state.AppDetails);
            SetReady(true);
        }

        setData();
    }, [ props.location.state.AppDetails ]);

    const handleChange = async (Value, Field) => {

        SetApp({ ...App, [Field]: Value });
    }

	return (
		<Container fluid className="main-content-container px-4">
			<Row noGutters className="page-header py-4">
                <Col className="col-12">
				    <PageTitle title="Edit" subtitle="App" md="12" className="ml-sm-auto mr-sm-auto" />
                </Col>
			</Row>
			<Row>
				<Col lg="4">
					{ Ready && <AppView App={ App } /> }
				</Col>
				<Col lg="8">
					{ Ready && <AppDetails App={ App } Change={ handleChange } /> }
				</Col>
			</Row>
		</Container>
	);
}

export default AppDetailsView;
